import React, { useContext, useEffect, useState } from "react";
import JobSection from "../../../molecules/NewLeadsForms/new-leads-job-section/JobSection";
import LeadSection from "../../../molecules/NewLeadsForms/new-leads-lead-section/LeadSection";
import AddressSection from "../../../molecules/NewLeadsForms/new-leads-address-section/AddressSection";
import CallDetailsSection from "../../../molecules/NewLeadsForms/new-leads-call-details-section/CallDetailsSection";
import LeadDatedSection from "../../../molecules/NewLeadsForms/new-leads-leadDated-section/LeadDatedSection";
import AddRecordingSection from "../../../molecules/NewLeadsForms/new-leads-addRecording-section/AddRecordingSection";
import { TypeSection } from "../../../molecules/NewLeadsForms/new-leads-type-section/TypeSection";
import { FormikTouched, Field, FormikErrors } from "formik";
import { Customers } from "../../../../slices/clients/types";
import { UserSubmitForm } from "../../../../utils/helpers/helperMethods/Validations";
import { TodosContext } from "../../../../context/alert";
import LeadTypeToggle, {
  LeadTypeEnum,
} from "../../../molecules/NewLeadsForms/new-leads-leadType-toogle/LeadTypeToggle";
import { LEAD_TYPE } from "../../../../pages/leads-management/models/ILead";
import { selectLeadType } from "../../../../slices/leads/leadManagementSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../slices/store";
import { useSelectedLeadType } from "../../../../slices/leads/selector";
import { scrollToTop } from "../../../../utils/helpers/helperMethods/scrollToTop";
interface Button {
  name: string;
  class1: string;
  type: string;
  onClick?: string | null;
}

interface Props {
  onChange: (e: any) => void;
  handleDate: (date: any) => void;
  handleRecording: (e: any) => void;
  onDeleteRecording: () => void;
  customers: Customers | undefined;
  newLeadContent: Object;
  inputValue: Object;
  buttons: Button[];
  errors: FormikErrors<UserSubmitForm>;
  startDate: any;
  touched: FormikTouched<any>;
  setErrors: any;
  recordUrl: any;
  hasFile: boolean;
  isUploading?: boolean;
  handleSetAddressValuesByGoogleAPI: (value: any, name: string) => void;
  handleCustomerValues: (value: any) => void;
  handleJobValues: (value: any) => void;
  handleBusinessType: (value: any) => void;
  handleCreateLead: () => void;
  validateForm: () => Promise<FormikErrors<UserSubmitForm>>;
}
const NewLeadAddSection = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { addAlert } = useContext(TodosContext);
  const leadType = useSelectedLeadType();

  useEffect(() => {
    props.setErrors(props.errors);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.errors]);

  const handleLeadType = (value: LEAD_TYPE) => {
    dispatch(selectLeadType(value));
  };

  return (
    <>
      <LeadTypeToggle
        onChange={(value) => handleLeadType(value)}
        defaultValue={leadType}
      />
      <JobSection {...props} />
      <LeadSection {...props} />
      {leadType === LEAD_TYPE.BUSINESS && <TypeSection {...props} />}
      <AddressSection {...props} />
      <AddRecordingSection {...props} />
      <LeadDatedSection {...props} />
      <CallDetailsSection {...props} />
      <div className="footer-section box-container">
        {props.buttons?.map((button: any, key: number) => (
          <button
            key={key}
            className={button.class1}
            type={button.type}
            onClick={async () => {
              // 1️⃣ Back button → browser back
              if (button.name === "Back") {
                window.history.back();
                return;
              }

              // 2️⃣ Submit button → validate + create
              const validationErrors = await props.validateForm();

              const hasNoErrors = Object.values(validationErrors).every(
                (value) => !value
              );

              if (hasNoErrors) {
                props.handleCreateLead();
              } else {
                const firstErrorMessage =
                  Object.values(validationErrors).find(Boolean) ||
                  "Please fill the required fields";

                scrollToTop();
                addAlert(firstErrorMessage, "failed", true);
              }
            }}
          >
            {button.name}
          </button>
        ))}
      </div>
    </>
  );
};

export default NewLeadAddSection;
